import {
  DATE_FORMAT,
  DATE_PICKER_DATE_FORMAT,
  EventEmitter,
  getTranslatedText,
  Tooltip
} from '@nile/components';
import { Label, TextField } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import dayjs from 'dayjs';
import React from 'react';
import DatePicker from 'react-datepicker';

function EndDate(props) {
  const {
    minDate,
    endDate,
    handlePropChange,
    handlePropertiesChange,
    remindDuration,
    intl,
    isDisabled,
    enableReminder,
    disablePastDateAndTime
  } = props;

  const minimumDate = minDate
    ? dayjs(minDate).toDate()
    : dayjs(new Date()).toDate();

  const disablePastProps = disablePastDateAndTime
    ? {
        filterTime: (val) => {
          const currentDate = new Date();
          const selectedDate = new Date(val);
          return currentDate.getTime() < selectedDate.getTime();
        },
        minDate: minimumDate
      }
    : {};

  return (
    <div className="flex">
      <div className="flex fcol">
        <Label>
          <FormattedMessage id="client.details.contractLineItem.endDate" />
        </Label>
        <DatePicker
          minDate={minimumDate}
          selected={endDate && dayjs(endDate).toDate()}
          onChange={(date) => {
            const formattedDate = date ? dayjs(date).format(DATE_FORMAT) : null;
            if (enableReminder && handlePropertiesChange && !date) {
              handlePropertiesChange({
                endDate: formattedDate,
                remindDuration: null
              });
            } else {
              handlePropChange('endDate', formattedDate);
            }
            EventEmitter.dispatch('fetchNextBillDate');
          }}
          placeholderText={DATE_FORMAT}
          dateFormat={DATE_PICKER_DATE_FORMAT[DATE_FORMAT]}
          title={getTranslatedText(
            intl,
            'client.details.contractLineItem.endDate'
          )}
          {...disablePastProps}
          required
          disabled={isDisabled}
          showYearDropdown
          showMonthDropdown
        />
      </div>
      {enableReminder && (
        <Tooltip
          html={
            <div>
              {getTranslatedText(
                intl,
                'client.details.contract.disableReminder'
              )}
            </div>
          }
          delay={400}
          duration={250}
          position="bottom"
          inertia
          trigger="mouseenter"
          animation="shift"
          animateFill={false}
          disabled={!!endDate}
        >
          <div
            className={`flex fcol ml-10 tippy-content ${
              !endDate ? 'sops-opacity-7 cursor-not-allowed' : ''
            }`}
          >
            <div className="mb5 nowrap">
              <Label>
                <FormattedMessage id="client.details.contractLineItem.reminder" />
              </Label>
            </div>
            <TextField
              type="number"
              value={remindDuration?.quantity?.toString() ?? null}
              onChange={(value) => {
                handlePropChange(
                  'remindDuration',
                  value
                    ? {
                        unit: 'DAY',
                        quantity: value
                      }
                    : null
                );
              }}
              disabled={!endDate}
              suffix={getTranslatedText(
                intl,
                'admin.projectTemplate.endDate.custom.days'
              )}
            />
          </div>
        </Tooltip>
      )}
    </div>
  );
}

export { EndDate };
